/**
 * Format URL parameters for PPC
 *
 * @param {String} url
 * @param {Array} ppc
 * @returns {String}
 */
export const formatURLforPPC = ({
  url = null,
  ppc = [{
    itm_medium: null,
    itm_source: null,
    itm_campaign: null,
    itm_content: null,
  }],
}) => {
  if (url) {
    let newUrl;

    if (url.startsWith('http://') || url.startsWith('https://')) {
      try {
        newUrl = new URL(url);
      } catch (error) {
        return url;
      }
    } else {
      if (url.startsWith('#')) {
        return url;
      }
      try {
        // add temporary base URL, in order to get the url as an object
        newUrl = new URL(url, 'https://example.com/');
      } catch (error) {
        return url;
      }
    }

    if (newUrl) {
      const searchParams = new URLSearchParams(newUrl.search);

      if (searchParams && ppc) {
        if (ppc.itm_medium && searchParams.has('itm_medium')) {
          newUrl.searchParams.set('itm_medium', ppc.itm_medium);
        }

        if (ppc.itm_source && searchParams.has('itm_source')) {
          newUrl.searchParams.set('itm_source', ppc.itm_source);
        }

        if (ppc.itm_campaign && searchParams.has('itm_campaign')) {
          newUrl.searchParams.set('itm_campaign', ppc.itm_campaign);
        }

        if (ppc.itm_content && searchParams.has('itm_content')) {
          newUrl.searchParams.set('itm_content', ppc.itm_content);
        }
      }

      // Handle the case where the url is relative by removing the temporary base URL
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        const newSearchParams = new URLSearchParams(newUrl.search);
        const urlWithoutSearchParams = url.split('?')[0];
        if (urlWithoutSearchParams && newSearchParams) {
          return JSON.stringify(`${urlWithoutSearchParams}?${newSearchParams}`)
            .replace(/"/g, '');
        }
      }
      return JSON.stringify(newUrl)
        .replace(/"/g, '');
    }
  }

  return url;
};
